import { Button, Icon } from '@lightspeed/design-system-react'
import React, { FunctionComponent, MouseEvent } from 'react'
import { EVENT } from '../../../constants'
import { canRemoveCustomerFromSale } from '../../../functions/sale'
import { useSaleManager } from '../../../ng-compat/hooks'
import { $rootScope } from '../../../ng-compat/imports'
import { useAppSelector } from '../../../state/hooks'
import { selectCurrentSale } from '../../../state/slices/currentSale/currentSaleSlice'

interface RemoveCustomerProps {
  onCustomerRemoved?: () => void
}

export const RemoveCustomerButton: FunctionComponent<RemoveCustomerProps> = ({
  onCustomerRemoved,
}) => {
  const sale = useAppSelector(selectCurrentSale)
  const saleManager = useSaleManager()

  const removeCustomer = async () => {
    await saleManager.removeCustomer()
    $rootScope.$emit(EVENT.SALE_UPDATE_TENDERED_AMOUNT)
    if (onCustomerRemoved) {
      onCustomerRemoved()
    }
  }

  const handleCustomerRemove = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    removeCustomer()
  }

  if (!canRemoveCustomerFromSale(sale)) {
    return null
  }

  return (
    <Button
      variant="no"
      type="button"
      modifier="icon"
      onClick={handleCustomerRemove}
      data-track="remove-customer"
      className="wr-customer-badge-remove vd-mt0 vd-mb0"
    >
      <Icon icon="fa-trash"></Icon>
    </Button>
  )
}
